export const TranslationIdMap = '';

export const TranslationKeyMap = {
    '_9297_YES': 'Yes',
    '_9298_NO': 'No',
    '_9479_CONFIRMATION': 'Confirmation',
    '_7360_FILTER': 'Filter',
    '_10035_ACTIVE_BEHAVIORS': 'Active Behaviours',
    '_10036_DRAFT_BEHAVIOURS': 'Draft Behaviours',
    '_10037_RECENTLY_CLOSED_BEHAVIOURS': 'Recently Closed Behaviours',
    '_10038_UNASSOCIATED_TRANSCRIPTS': 'Unassociated Transcripts',
    '_10039_ORDER_BY': 'Order by',
    '_10040_BY_DATE_MOST_RECENT': 'By Date Most Recent',
    '_10041_BY_DATE_OLDEST': 'By Date Oldest',
    '_10042_ALPHABETICAL_A_TO_Z': 'Alphabetical A to Z',
    '_10043_ALPHABETICAL_Z_TO_A': 'Alphabetical Z to A',
    '_10044_BY_DATE': 'By Date',
    '_10045_BY_PARTICIPANT': 'By Participant',
    '_10046_BY_BEHAVIOUR': 'By Behaviour',
    '_10047_BY_SUB_BEHAVIOUR': 'By Tactic',
    '_10048_SUB_BEHAVIOUR': 'Tactic',
    '_9301_DESCRIPTION': 'Description',
    '_9681_PARTICIPANTS': 'Participants',
    '_10049_OPEN_TRANSCRIPT': 'Open Transcript',
    '_10050_DELETE_TRANSCRIPT': 'Delete Transcript',
    '_10051_NO_TRANSCRIPTS_AVAILABLE': 'No Transcripts Available',
    '_10052_ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_TRANSCRIPT_': 'Are you sure you want to delete this transcript?',
    '_10053_NO_FOCUS_SELECTED': 'No Focus Selected',
    '_10054_TRANSCRIPT_ID': 'Transcript ID',
    '_9996_TRANSCRIPTS': 'Transcripts',
    '_710_SEARCH': 'Search',
    '_10055_LOAD_MORE___': 'Load more...',
    '_9665_RESET': 'Reset',
    '_9774_START_DATE_': 'Start Date:',
    '_73_END_DATE_': 'End Date',
    '_11221_IMPORT_TRANSCRIPTS': 'Import Transcripts'
};
